import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import KnowledgeBanner from './KnowledgeBanner';
import {useSelector, useDispatch} from 'react-redux';
import {useNavigate} from "react-router-dom";
import { downloadFile, watchVideoOnPopup} from '../../common/Helper';
import allActions from '../../../actions/index';


function CTMain() {

  const knowledgeCenterBucketState =  useSelector(state => state.KnowledgeCenterBucket);
  const knowledgeCenterClearTrailBucketState = knowledgeCenterBucketState.bucket.cleartrail


  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [activeTab, setActiveTab] = useState("tab0");

  function tabClick(event){
      setActiveTab(event.target.getAttribute('tabid'));
  };


  /******Watch video on popup*****/
  function watchVideoOnPopup(link){
        //link = 'https://player.vimeo.com/video/46926279';
        dispatch( allActions.ModalPopup.pushPopupData({image:"",title:"",download_link:link,popupname:"videoshow"}));
        dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:"videoshow"}));
    }

  function showRequestDemoKnowledgeCenter(event){
      console.log(event.target.title, "after click");
      var title =  event.target.title;
      var demoname = event.target.attributes.getNamedItem('requestdemoname').value;

      //console.log(data, "after click");
         dispatch( allActions.ModalPopup.pushPopupData({image:"",title:"You are about to submit a request for Product "+demoname,download_link:title+" || "+demoname,popupname:"requestdemo"}));
         dispatch( allActions.ModalPopup.showPopupByPopupName({ popupname:"requestdemo"}));
  }

  function GridData(elements){
    const {image, title, type, link} = elements.data;


    const buttonTag = (type==="Video" 
                ? 
                <button className="column-download-btn" onClick={(event) => watchVideoOnPopup(link)} ><p className="column-download-btn" rel="noopener"> Watch Now&nbsp;→</p></button>
                : 
                <button className="column-download-btn" data-title={title} data-type={type} onClick={(event) => downloadFile(event, link)} ><span className="material-icons-outlined">file_download</span> Download</button>
                );


    if(elements.layout===1){

        return ( <div className="column-section 11">    
                        <div className="column-image">
                            <img src={image} alt="" />
                        </div>
                        <h3>{title}</h3>
                        {link && buttonTag}
                </div>);
    }else{

        return (<div className="column-section column-2-box">    
                        <div className="column-image">
                            <img src={image} alt="" />
                        </div>
                        <h3>{title}</h3>
                        {link && buttonTag}
                       
                </div>);
    }
    
  }

  if(knowledgeCenterClearTrailBucketState.disable=="yes"){
      navigate('/');
  }

  if(knowledgeCenterClearTrailBucketState.disable=="no" || knowledgeCenterClearTrailBucketState.disable==""){
    
    var tabsData = knowledgeCenterClearTrailBucketState.data;
    // console.log(tabsData);
    // console.log(knowledgeCenterClearTrailBucketState.length, "length");

   var loaderData =  knowledgeCenterBucketState.datatrack === 1 ? "fullpage-box knowledge-fullpage-box loader-data" : "fullpage-box knowledge-fullpage-box";

  return (
    <>             
            <div className={loaderData}> 
            <div className="fullpage-inner-box">
            

                {/* Banner start */}
                <KnowledgeBanner />
                {/* Banner end */}


                  {/* container start */}
                  <div className="container">
                  

                  
                      {/* Tab nav */}
                      <div className="SubTabs">

                        {/*********Tabs define*********/}
                        <ul>
                        {
                            tabsData.map((element, index) => {
                                if(element.disable!="yes"){
                                    return <li key={index} className={activeTab === "tab"+index ? "active" : ""}>
                                                <button type="button" rel="tab" tabid={"tab"+index} className="tab-nav" onClick={tabClick} >{element.tabtitle}</button>
                                            </li>
                                }

                            })
                        }

                        </ul>
                        
                
                            {tabsData &&
                                tabsData.map((element, index) => {
                                    if(element.disable!="yes"){

                                        var inner_data_level = element.inner_data;
                                        return  <div key={index} tabid={"tab"+index} className={activeTab === "tab"+index ? "tab-content active" : "tab-content"}>

                                            <div className="subtab-content">
                        
                                                <div>
                                                                                                            
                                                        {inner_data_level &&
                                                        inner_data_level.map((element_inner, index_inner) => {
                                                                var section_rows_inner = element_inner.section_row;
                                                            return  <React.Fragment key={index_inner}><h3 className="section-title">{element_inner.section_heading}</h3><div className="column-box">
                                                        

                                                                {section_rows_inner && 
                                                                    section_rows_inner.map((element_grid, index_grid) => {
                                                                        
                                                                        if(element.tabtitle==="Sessions"){
                                                                            return <GridData data={element_grid} layout={1} key={Math.random() * 10}/>
                                                                        }else{
                                                                            return <GridData data={element_grid}  layout={2} key={Math.random() * 10}/>
                                                                        }

                                                                    })
                                                                }

                                                                </div></React.Fragment>

                                                        })
                                                        }
                                                        <div className="text-center mt-30">
                                                        
                                                        {element.requestdemoname && <button type="button" className="btn open-details" title={element.tabtitle} requestdemoname={element.requestdemoname} onClick={(event) => showRequestDemoKnowledgeCenter(event)}>Request {element.requestdemoname}</button>}
                                                        
                                                        </div>
                                                </div>
                                                
                                            </div>

                                        </div>
                                    }

                                })
                            }

                    
                            
                        
                      </div>
                  
              
                  </div>
                  {/* container end */}

            </div>
        </div>

    </>
  );

}

};
export default CTMain;